import { render } from "./youtube.vue?vue&type=template&id=445ec80c"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__